import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { orderId: Number }

  connect() {
    // Intentar abrir inmediatamente
    this.openOrderCard()

    // También escuchar eventos de turbo frame por si el contenido se carga después
    this.boundOpenOrderCard = () => this.openOrderCard()
    document.addEventListener('turbo:frame-load', this.boundOpenOrderCard)
  }

  disconnect() {
    // Limpiar el listener cuando el controlador se desconecta
    if (this.boundOpenOrderCard) {
      document.removeEventListener('turbo:frame-load', this.boundOpenOrderCard)
    }
  }

  openOrderCard() {
    if (!this.orderIdValue) return

    const orderId = this.orderIdValue
    const orderElement = document.getElementById('order-' + orderId)

    if (orderElement) {
      // Hacer scroll al elemento
      orderElement.scrollIntoView({ behavior: 'smooth', block: 'center' })

      // Asegurar que el collapse esté abierto
      const collapseElement = document.getElementById('collapse' + orderId)
      if (collapseElement) {
        // Usar Bootstrap collapse si está disponible
        if (typeof bootstrap !== 'undefined' && bootstrap.Collapse) {
          let collapseInstance = bootstrap.Collapse.getInstance(collapseElement)
          if (!collapseInstance) {
            collapseInstance = new bootstrap.Collapse(collapseElement, { toggle: false })
          }
          collapseInstance.show()
        } else if (typeof $ !== 'undefined' && $.fn.collapse) {
          // Fallback para jQuery Bootstrap
          $(collapseElement).collapse('show')
        } else {
          // Fallback manual
          collapseElement.classList.add('show')
          const trigger = document.querySelector('[data-target="#collapse' + orderId + '"]')
          if (trigger) {
            trigger.classList.remove('collapsed')
            trigger.setAttribute('aria-expanded', 'true')
          }
        }
      }
      return true
    }

    // Si no se encontró, intentar de nuevo después de un breve delay
    setTimeout(() => {
      if (!document.getElementById('order-' + orderId)) {
        // Solo intentar una vez más si aún no existe
        setTimeout(() => this.openOrderCard(), 200)
      } else {
        this.openOrderCard()
      }
    }, 100)

    return false
  }
}
